var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6869_3131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6643 9.10415L16.6332 6.07305V2.57162C16.6332 1.93851 16.1202 1.42543 15.4861 1.42543C14.8535 1.42543 14.3405 1.93851 14.3405 2.57162V3.78039L12.0836 1.52341C10.9678 0.408189 9.02771 0.410167 7.91442 1.52543L0.335548 9.10415C-0.111849 9.55243 -0.111849 10.2778 0.335548 10.7254C0.783148 11.1736 1.50992 11.1736 1.95736 10.7254L9.53551 3.14647C9.78238 2.90089 10.2175 2.90089 10.4631 3.14575L18.0425 10.7254C18.2673 10.9495 18.5603 11.061 18.8532 11.061C19.1468 11.061 19.4403 10.9494 19.6643 10.7254C20.1119 10.2778 20.1119 9.55247 19.6643 9.10415Z",
    fill: "#505766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3981 5.32228C10.1779 5.10221 9.82136 5.10221 9.60182 5.32228L2.93543 11.9867C2.83018 12.0919 2.77051 12.2355 2.77051 12.3854V17.2462C2.77051 18.3868 3.69534 19.3116 4.83592 19.3116H8.13646V14.2002H11.8627V19.3116H15.1633C16.3038 19.3116 17.2287 18.3868 17.2287 17.2463V12.3854C17.2287 12.2355 17.1695 12.0919 17.0637 11.9867L10.3981 5.32228Z",
    fill: "#505766"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6869_3131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e500011ee9dff0f437fb1cac1301f83e.svg";
export { ForwardRef as ReactComponent };